import { Icon } from "@iconify/react/dist/iconify.js";
import { ActionIcon, Button, Group, Modal, Text } from "@mantine/core";
import { useFetcher } from "@remix-run/react";
import { useState } from "react";

export function ImpersonationBanner({
  targetName,
}: {
  targetName: string | null;
}) {
  const [stopModalOpened, setStopModalOpened] = useState(false);
  const fetcher = useFetcher();

  const handleStop = () => {
    setStopModalOpened(false);
    fetcher.submit(
      {},
      {
        method: "post",
        encType: "application/json",
        action: "/impersonate/stop",
      },
    );
  };

  return (
    <>
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
        <div className="flex items-center gap-2 px-4 py-2 rounded-full shadow-lg bg-orange-600 text-white">
          <Icon
            icon="material-symbols:supervisor-account"
            className="text-lg"
          />
          <span className="text-sm font-medium">
            Impersonating: {targetName ?? "user"}
          </span>
          <ActionIcon
            variant="transparent"
            color="white"
            aria-label="Stop impersonate"
            onClick={() => setStopModalOpened(true)}
          >
            <Icon icon="material-symbols:close-rounded" />
          </ActionIcon>
        </div>
      </div>

      <Modal
        opened={stopModalOpened}
        onClose={() => setStopModalOpened(false)}
        title="Hentikan Impersonate"
        centered
      >
        <Text size="sm" mb="lg">
          Yakin ingin menghentikan impersonate atas{" "}
          <strong>{targetName ?? "user"}</strong> dan kembali ke mode superadmin?
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={() => setStopModalOpened(false)}>
            Batal
          </Button>
          <Button
            color="red"
            loading={fetcher.state !== "idle"}
            onClick={handleStop}
          >
            Hentikan Impersonate
          </Button>
        </Group>
      </Modal>
    </>
  );
}
